import { connect } from 'react-redux';

import { selectors as createSelectors } from 'dux/createInstance';
import { actionCreators as clickTrackerActionCreators } from 'dux/clickTracker';
import { selectors as orgSelectors } from 'dux/org';
import ServiceSelector from './ServiceSelector';

function mapStateToProps(state, ownProps) {
  return {
    selectedService: createSelectors.selectedServiceSelector(state),
    isServiceBeta: createSelectors.isServiceBetaSelector(state, ownProps),
    versionNamesByService: createSelectors.versionNamesByServiceSelector(state, ownProps),
    orgIsAwsOnly: orgSelectors.awsOnlySelector(state),
  };
}

const mapDispatchToProps = {
  trackButtonClick: clickTrackerActionCreators.trackButtonClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceSelector);
